import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            网友热评
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            数百万吃瓜群众在热议什么？看看大家的真实观点
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-heart-line"></i>
                  <span>{item.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line"></i>
                  <span>分享</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}